import { useEffect, useRef, useState } from "react";
import UserFeedCard from './UserFeedCard';
import { AppPaths } from "../../utils/AppPaths";
import { useNavigate } from "react-router-dom";
import ApiService from "../../api/ApiServices";



const Feeds = ({ feedData, coachMarkStep }: { feedData: any[]; coachMarkStep?: number }) => {
  const navigate = useNavigate();
  const menuRef = useRef<HTMLDivElement | null>(null);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isFlagModalOpen, setIsFlagModalOpen] = useState(false);
  const [isFlagReasonOpen, setIsFlagReasonOpen] = useState(false);
  const [flagReason, setFlagReason] = useState("");
  const [flagReasonError, setFlagReasonError] = useState("");
  const challenge = feedData?.[0];
  const challengeType = challenge?.type;
  const challengeFeeds = challenge?.feeds || [];
  const showSeeAll = Number(challenge?.feedCount) > 2;

  const normalizedFeeds = challengeFeeds.map((feed: any) => ({
    ...feed,
    challengeId: {
      _id: challenge?._id,
      title: challenge?.title,
      type: challengeType,
    },
  }));

  const handleChallenge = (type: string, id: string) => {
    if (type === 'text') {
        navigate(`${AppPaths.DANCE_CHALLENGE}?id=${id}`)
    } else if (type === 'image' || type === 'video') {
        navigate(`${AppPaths.HALLOWEEN_CHALLENGE}?id=${id}&type=${type}`)
    } else {
        navigate(`${AppPaths.FALLFUN_QUIZ_CHALLENGE}?id=${id}`)
    }
  }

  const handleFlagChallenge = () => {
    setIsMenuOpen(false);
    setIsFlagModalOpen(true);
  };

  const handleConfirmFlag = () => {
    setIsFlagModalOpen(false);
    setIsFlagReasonOpen(true);
    setFlagReasonError("");
  };

  const handleSubmitFlag = async () => {
    const reason = flagReason.trim();

    if (!reason) {
      setFlagReasonError("Reason is required.");
      return;
    }

    if (!challenge?._id) {
      return;
    }

    try {
      await ApiService.markAttemptChallengeInappropriate(challenge._id, reason);
      setIsFlagReasonOpen(false);
      setFlagReason("");
      setFlagReasonError("");
    } catch (error) {
      console.error("Failed to flag challenge", error);
    }
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
        setIsMenuOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  if (!challenge) {
    return null;
  }

  return (
    <>
    <div className={`min-h-screens coach-view-house-feed ${
                coachMarkStep === 6 ? "coach-view-house-feed-highlight" : ""}`}>

      <section className="mb-6">
        <div className="px-3 py-1">
          <div className="flex items-start justify-between gap-3">
            <h2
              className="inter-text-18-semibold cursor-pointer flex-1"
              onClick={() => handleChallenge(challengeType, challenge?._id)}
            >
              {challenge?.title}
            </h2>
            <div className="relative flex-shrink-0" ref={menuRef}>
              <button
                type="button"
                aria-label="More options"
                className="flex items-center gap-1 pt-1"
                onClick={() => setIsMenuOpen((prevState) => !prevState)}
              >
                <span className="h-1.5 w-1.5 rounded-full bg-[#BFBFBF]" />
                <span className="h-1.5 w-1.5 rounded-full bg-[#BFBFBF]" />
                <span className="h-1.5 w-1.5 rounded-full bg-[#BFBFBF]" />
              </button>

              {isMenuOpen && (
                <div className="absolute right-0 top-full z-20 mt-4 min-w-[170px] flag-menu bg-white p-1">
                  <button
                    type="button"
                    className="flex w-full items-center justify-center px-1 py-1 text-left  hover:bg-[#F7F7F7] inter-regular-14"
                    onClick={handleFlagChallenge}
                  >
                    Flag this challenge
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
        
        <div className="divide-y divide-gray-100">
          {normalizedFeeds.map((post: any) => (
            <UserFeedCard 
              key={post._id} 
              type={challengeType} 
              data={post} 
            />
          ))}
        </div>
        
        {showSeeAll && (
          <div className="px-4 pt-2">
            <button
              type="button"
              className="inline-flex items-center gap-1 rounded-full bg-[#DADADA] px-2 inter-12-bold text-[#231F20]" style={{paddingTop: 3, paddingBottom: 2}}
              onClick={() => handleChallenge(challengeType, challenge?._id)}
            >
              <span aria-hidden="true">🔎</span>
              <span>See All</span>
            </button>
          </div>
        )}
      </section>
        <hr className="hr-feed my-6" />
    </div>

      {isFlagModalOpen && (
        <div className="flag-modal-overlay" onClick={() => setIsFlagModalOpen(false)}>
          <div className="flag-modal-card" onClick={(e) => e.stopPropagation()}>
            <h2 className="flag-modal-title">Flag this Challenge?</h2>
            <p className="flag-modal-message">
              If this challenge has a response that is offensive or inappropriate, alert your House Lead to have it taken down.
            </p>
            <div className="flag-modal-actions">
              <button
                type="button"
                className="flag-modal-back-btn"
                onClick={() => setIsFlagModalOpen(false)}
              >
                BACK TO FEED
              </button>
              <button
                type="button"
                className="flag-modal-flag-btn"
                onClick={handleConfirmFlag}
              >
                FLAG
              </button>
            </div>
          </div>
        </div>
      )}

      {isFlagReasonOpen && (
        <div
          className="flag-modal-overlay"
          onClick={() => {
            setIsFlagReasonOpen(false);
            setFlagReasonError("");
          }}
        >
          <div className="flag-modal-card" onClick={(e) => e.stopPropagation()}>
            <h2 className="flag-modal-title">Flag this Challenge?</h2>
            <p className="flag-modal-message">Please describe what is inappropriate or offensive:</p>
            <input
              type="text"
              className={`flag-modal-input ${flagReasonError ? "flag-modal-input-error" : ""}`}
              placeholder="Enter your answer..."
              value={flagReason}
              onChange={(e) => {
                setFlagReason(e.target.value);
                if (flagReasonError) {
                  setFlagReasonError("");
                }
              }}
            />
            {flagReasonError && <p className="flag-modal-error-text">{flagReasonError}</p>}
            <div className="flag-modal-actions">
              <button
                type="button"
                className="flag-modal-back-btn"
                onClick={() => {
                  setIsFlagReasonOpen(false);
                  setFlagReasonError("");
                }}
              >
                BACK TO FEED
              </button>
              <button
                type="button"
                className="flag-modal-flag-btn"
                onClick={handleSubmitFlag}
              >
                SUBMIT
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Feeds;